import script from "./F2LCard.vue?vue&type=script&setup=true&lang=js"
export * from "./F2LCard.vue?vue&type=script&setup=true&lang=js"

import "./F2LCard.vue?vue&type=style&index=0&id=32867b40&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32867b40"]])

export default __exports__